export {default as OpaccAutoCompleter} from './autocomplete.js';